module.exports = __webpack_public_path__ + "img/gz.0132d1cd.png";